import { Controller } from "@hotwired/stimulus"
import { Tab } from "bootstrap"

export default class extends Controller {
  static targets = ["add", "tab"]

  static outlets = ["admin--quotes--option"]

  #revealing = false

  // The option added next copies the one open.
  select({ params: { index } }) {
    this.addTarget.value = index
  }

  // The browser can only point at a field it rejects on an open tab, so the tab of the first one it rejects opens. It
  // fires an invalid event for every rejected field, running microtasks in between, so the later ones are ignored until
  // a later task.
  reveal({ target }) {
    if (this.#revealing) return

    this.#revealing = true
    setTimeout(() => {
      this.#revealing = false
    })

    const option = this.adminQuotesOptionOutlets.find(({ element }) => element.contains(target))
    const tab = this.tabTargets.find(({ dataset }) => dataset.bsTarget === `#${option.element.id}`)
    Tab.getOrCreateInstance(tab).show()
  }
}
